/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ProcedureTransactionWriteoffViewModel {
  id?: string;
  balance?: number;
  isReversed?: boolean;
  fromDate?: string | null;
  modifier1Code?: string | null;
  modifier2Code?: string | null;
  modifier3Code?: string | null;
  modifier4Code?: string | null;
  procedureCode?: string | null;
  procedureDescription?: string | null;
  readonly procedureDescriptionOutput?: string | null;
}
